module.exports = __webpack_public_path__ + "img/pictureRed.7da7f7b7.jpg";